












































import Vue from 'vue';

export default Vue.extend({
  name: 'CouponTitle',
  props: {
    title: {
      type: String,
    },
    status: {
      type: String,
    },
  },
});
